import { literal, object } from "valibot"
import { baseCatalogueSchema } from "./catalogue"

/**
 * Schema for Crystallize documents. Will differ between the different document types, and should be extended for each use case.
 *
 * @see https://crystallize.com/learn/concepts/pim/document
 */
export const documentSchema = object({
  ...baseCatalogueSchema.entries,
  type: literal("document"),
})
